import { render, staticRenderFns } from "./LoopStaff.vue?vue&type=template&id=6086f4de&scoped=true"
import script from "./LoopStaff.vue?vue&type=script&lang=js"
export * from "./LoopStaff.vue?vue&type=script&lang=js"
import style0 from "./LoopStaff.vue?vue&type=style&index=0&id=6086f4de&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6086f4de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6086f4de')) {
      api.createRecord('6086f4de', component.options)
    } else {
      api.reload('6086f4de', component.options)
    }
    module.hot.accept("./LoopStaff.vue?vue&type=template&id=6086f4de&scoped=true", function () {
      api.rerender('6086f4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/loop/components/LoopStaff.vue"
export default component.exports